import {
  beAccountSettingsGetAccountSmsCredits,
  beAccountSettingsGetSmsCosts
} from 'Api/beAccountSettingsApi'
import { beMessSendApiGetSmsSendingDetails } from 'Api/BeMessSendApi'
import {
  beQueueGetConfiguration,
  beQueueGetQueuedSmsRecipientsCountby,
  beQueueGetSendingsTotalCost
} from 'Api/beQueueApi'
import { beSmsAliasIsSmsAliasAuthorized } from 'Api/beSmsAlias'
import { beSmsSendSetSendingType } from 'Api/beSmsSend'
import { STORE_KEY_ID_LIST } from 'Constants'
import { storeGet } from 'mailup-react-helpers'

export async function getSmsCosts(fieldName, date) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const smsCost = await beAccountSettingsGetSmsCosts(idList)
  return smsCost
}

export async function getConfiguration(idConf) {
  const ret = await beQueueGetConfiguration(idConf)
  return ret
}

export async function getAccountSmsCredits() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const ret = await beAccountSettingsGetAccountSmsCredits(idList)
  return ret
}

export async function getSendingsTotalCost(idSend) {
  const data = {
    SendingIds: [idSend]
  }
  const ret = await beQueueGetSendingsTotalCost(data)
  return ret
}

export async function getSmsSendingDetails(idSend) {
  const ret = await beMessSendApiGetSmsSendingDetails(idSend)
  return ret
}

export async function isSmsAliasAuthorized(alias) {
  const ret = await beSmsAliasIsSmsAliasAuthorized(alias)
  return ret
}

export async function getQueuedSmsRecipientsCountby(idSending, params) {
  const ret = await beQueueGetQueuedSmsRecipientsCountby(idSending, params)
  return ret
}

export async function setSendingType(idSending, params) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const ret = await beSmsSendSetSendingType(idList, idSending, params)
  return ret
}
